import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import Modal from '../../../_common/Modal/Modal';
import classes from './repBonus.module.scss';
import Utils from '../../../../utils/utils';
import Select from '../../../_common/Form/Selects/Select/Select';
import InputField from '../../../_common/Form/TextFields/InputField';
import Button from '../../../_common/Form/Buttons/Button';

const RepBonusModal = ({
  modalInfo, onClose, onPay, changeData, payAmountError, savePaymentLoading, setDeleteInfo,
}) => (
  <Modal
    className={classes.rep_bonus_modal}
    open={modalInfo.isOpen}
    onClose={onClose}
  >
    <div className={classes.modal_wrapper}>
      <h2>{modalInfo.payments ? (modalInfo.title || modalInfo.date) : 'Pay Bonus'}</h2>

      {modalInfo.payments
        ? (
          <div className={classes.payments_details_wrapper}>
            {modalInfo.payments.map(({
              id, payerName, createdAt, amount, paymentMethod, checkNumber,
            }) => (
              <div key={id} className={classes.payments_details}>
                <p>
                  {payerName}
                  {' '}
                  <span>{`Paid by ${paymentMethod}${paymentMethod === 'Check' && checkNumber ? ` (${checkNumber})` : ''} at ${moment(createdAt).format('MM/DD/YYYY hh:mm A')}`}</span>
                </p>

                <div>
                  <p>{`$${Utils.formattingCurrency(amount)}`}</p>

                  <Button
                    title="Cancel"
                    buttonColor="#5F6C8E"
                    onClick={() => setDeleteInfo({
                      isOpen: true,
                      id,
                      amount,
                      date: moment(modalInfo.date).format('YYYY-MM'),
                    })}
                  />
                </div>
              </div>
            ))}
          </div>
        )

        : (
          <form onSubmit={onPay}>
            <Select
              label="Payment Method"
              onChange={(option) => changeData('paymentMethod', option)}
              currentOption={modalInfo.paymentMethod}
              options={['Cash', 'Check']}
              zIndex={30}
              hideClearButton
            />

            {modalInfo.paymentMethod === 'Check' && (
            <InputField
              label="Check Number"
              value={modalInfo.checkNumber}
              onChange={(value) => changeData('checkNumber', value)}
            />
            )}

            <InputField
              label="Amount"
              value={modalInfo.amount}
              error={payAmountError}
              onChange={(value) => changeData('amount', value)}
              onKeyPress={(e) => Utils.keyPressCurrency(e, false, undefined, 3)}
              onPaste={(e) => Utils.keyPressCurrency(e, true, undefined, 3)}
            />

            <div className={classes.btn_wrapper}>
              <Button
                title="Confirm"
                type="submit"
                reverseColor
                loading={savePaymentLoading}
              />

              <Button
                onClick={onClose}
                title="Cancel"
                type="button"
                clearButton
              />
            </div>
          </form>
        )}
    </div>
  </Modal>
);

RepBonusModal.propTypes = {
  modalInfo: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    payments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        payerName: PropTypes.string.isRequired,
        createdAt: PropTypes.string.isRequired,
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      }),
    ),
    date: PropTypes.string,
    paymentMethod: PropTypes.string,
    checkNumber: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onPay: PropTypes.func.isRequired,
  changeData: PropTypes.func.isRequired,
  payAmountError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  savePaymentLoading: PropTypes.bool,
};

export default RepBonusModal;
